import {createAction, props} from '@ngrx/store';
import {Fence} from '@app/rest-client/faxe/models/fence';
import { FenceRace } from '@app/store/faxe/fences/model/fence-race';

const prefix = '[FAXE-FENCE]';

export const fetchAllFences = createAction(
  `${prefix} - fetch all`,
  props<{raceGuid: string;  issuerStack: string[] }>()
);

export const getFences = createAction(
  `${prefix} - get`,
  props<{raceGuid: string;  issuerStack: string[] }>()
);

export const addFence = createAction(
  `${prefix} - add`,
  props<{ model: FenceRace; issuerStack: string[] }>()
);

export const addManyFences = createAction(
  `${prefix} - add many`,
  props<{ models: FenceRace[]; issuerStack: string[] }>()
);

export const postFence = createAction(
  `${prefix} - post`,
  props<{ fences: FenceRace[]; issuerStack: string[] }>()
);

export const removeFence = createAction(
  `${prefix} - remove`,
  props<{ fenceId: string; issuerStack: string[] }>()
);

export const reloadFences = createAction(
  `${prefix} - reload`,
  props<{ issuerStack: string[] }>()
);
